import {buttonVariants} from '@/components/app/button';
import {InfoSection} from '../../../../app/components/InfoSection';
import {SuccessComponentProps} from '../../type';
export const SuccessResetPassword = (props: SuccessComponentProps) => {
  return (
    <InfoSection
      {...props}
      actions={[
        {
          props: {
            className: buttonVariants({className: 'rounded-full hover:no-underline'}),
            children: 'Go to Login',
            to: '/sign-in',
          },
          type: 'link',
        },
      ]}
      message={
        <>
          Your password is changed successfully. <br /> You can continue to use Biotandem by using your new password.
        </>
      }
    />
  );
};
